import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5b76db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "type"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "custom-btn__icon center" }
const _hoisted_4 = { class: "custom-btn__active-icon center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "custom-btn__spinner center"
}

import { computed } from 'vue';
import { ButtonTypesType } from '@/types';
import { RouteRecordNormalized } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    text: {},
    styleType: { default: 'colored' },
    icon: { type: Boolean, default: false },
    allBlockWidth: { type: Boolean, default: false },
    width: {},
    height: { default: '28' },
    padding: {},
    active: { type: Boolean, default: false },
    withoutActive: { type: Boolean, default: false },
    beforeIcon: { default: undefined },
    type: { default: 'button' },
    loading: { type: Boolean },
    disabled: { type: Boolean },
    href: {},
    bgColor: {},
    uppercase: { type: Boolean }
  },
  emits: ['click', 'mousedownHandler'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const btnClass = computed((): string => {
  let classForBtn: string;

  switch (props.styleType) {
    case 'coloredBorder':
      classForBtn = 'custom-btn--colored-border-btn gradient';
      break;
    case 'border':
      classForBtn = 'custom-btn--border-btn';
      break;
    case 'greyBorder':
      classForBtn = 'custom-btn--grey-border-btn';
      break;
    case 'greenBorder':
      classForBtn = 'custom-btn--green-border-btn';
      break;
    case 'translucent':
      classForBtn = 'custom-btn--translucent-btn';
      break;
    case 'translucentGreen':
      classForBtn = 'custom-btn--translucent-green-btn';
      break;
    case 'white':
      classForBtn = 'custom-btn--white-btn';
      break;
    case 'grey':
      classForBtn = 'custom-btn--grey-btn';
      break;
    default:
      classForBtn = 'custom-btn--colored-btn';
  }

  return classForBtn;
});

const clickHandler = () => {
  emit('click');
};

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.href ? 'router-link' : 'div'), {
    style: _normalizeStyle([
      {
        width: _ctx.allBlockWidth ? '100%' : _ctx.width + 'px',
        height: _ctx.height === 'auto' ? 'auto' : _ctx.height + 'px',
      },
    ]),
    to: _ctx.href,
    class: "custom-btn-container"
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: _normalizeClass([[
        btnClass.value,
        { 'hover-btn': !_ctx.withoutActive },
        { icon: _ctx.icon, 'before-icon': _ctx.beforeIcon, active: _ctx.active },
        { withPadding: _ctx.height === 'auto' },
      ], "custom-btn"]),
        disabled: _ctx.disabled,
        style: _normalizeStyle([
        {
          width: _ctx.allBlockWidth ? '100%' : _ctx.width + 'px',
          height: _ctx.height === 'auto' ? 'auto' : _ctx.height + 'px',
          padding: `0 ${_ctx.padding}px`,
          backgroundColor: _ctx.bgColor,
        },
      ]),
        type: _ctx.type,
        onClick: clickHandler,
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('mousedownHandler', $event)))
      }, [
        (_ctx.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _renderSlot(_ctx.$slots, "icon")
              ]),
              _createElementVNode("span", _hoisted_4, [
                _renderSlot(_ctx.$slots, "iconActive")
              ])
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "text"),
        (_ctx.beforeIcon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.beforeIcon,
              alt: "icon"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createVNode(_component_base_spinner, {
                color: _ctx.styleType === 'coloredBorder' ? '#009D3E' : '#ffffff',
                size: _ctx.height - 10
              }, null, 8, ["color", "size"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass({
          'gradient-color': _ctx.styleType === 'coloredBorder',
          'custom-btn__loading-text': _ctx.loading,
          uppercase: _ctx.uppercase,
        })
        }, _toDisplayString(_ctx.text), 3)
      ], 46, _hoisted_1)
    ]),
    _: 3
  }, 8, ["style", "to"]))
}
}

})